import { defineStore } from 'pinia';
import { reactive } from 'vue';

import { getLocaleMessage } from '@/services/MessagesService';

import { useToast } from 'vue-toast-notification';
import { useLoadingStore } from '@/pinia/loading.module';
import FlowStatus from '@/Models/Documents/FlowStatus';
import { useAuthStore } from '@/pinia/auth.module';

import * as service from '@/services';

const $toast = useToast();

export const useFlowStatusStore = defineStore('flowStatusStore', {
    persist: false,
    state: () => {
        return {
            flowStatus: new FlowStatus(),
            errors: [],
        }
    },
    getters: {
        getFlowStatus: state => state.flowStatus,
        getFlowStatusByRole: state  => {
            const roles = useAuthStore().getRoles;
            // TODO: Check current roles from db Roles table
            if (roles.find(role => role.name === 'Ejecutivo' || role.name === 'Administrador')) {
                return state.flowStatus.operational;
            } else if (roles.find(role => role.name === 'Jurídico')) {
                return state.flowStatus.legal;
            } else if (roles.find(role => role.name === 'Oficial de Cumplimiento' || role.name === 'Administrador')) {
                return state.flowStatus.aml;
            } else {
                return false;
            }
        }
    },
    actions: {
        setErrors(errors) {
            this.errors.push(errors);
        },
        async fetchFlowStatusByLoanApplicationId(loanApplicationId) {
            try {
                useLoadingStore().loading = true;
                const { data } = await service.documentationApi.get(`/api/FlowStatus/${loanApplicationId}`);
                if (data && data.status) {
                    this.flowStatus = data.data;
                } else {
                    $toast.error(getLocaleMessage('common', 'backendError'));
                }
                useLoadingStore().loading = false;
            } catch (error) {
                useLoadingStore().loading = false;
                this.setErrors(error);

                if (error.response) {
                    // Error de respuesta desde la API (status code no 2xx)
                    this.setErrors(error.response.data);
                    $toast.error(getLocaleMessage('common', 'responseError'));
                } else if (error.request) {
                    // Error de red, no se recibió respuesta
                    $toast.error(getLocaleMessage('common', 'networkError'));
                } else {
                    // Otro tipo de error
                    $toast.error(getLocaleMessage('common', 'generalError'));
                }
            } finally {
                useLoadingStore().loading = false;
            }
        },
        /**
         * Guardado del estatus del checklist para edición de un registro
         * Permite guardar un registro nuevo de checklist en la tabla de FlowStatus
         * Permite la edición de un registro de checklist en la tabla de FlowStatus
         * @param {*} flowStatus 
         */
        async saveFlowStatus(flowStatus){
            try {
                useLoadingStore().loading = true;
                const { data } = await service.documentationApi.post(`/api/FlowStatus/save`, flowStatus);
                if (data && data.status) {
                    this.flowStatus = data.data;
                } else {
                    $toast.error(getLocaleMessage('common', 'backendError'));
                }
                useLoadingStore().loading = false;
            }catch (error) {
                useLoadingStore().loading = false;
                this.setErrors(error);

                if (error.response) {
                    // Error de respuesta desde la API (status code no 2xx)
                    this.setErrors(error.response.data);
                    $toast.error(getLocaleMessage('common', 'responseError'));
                } else if (error.request) {
                    // Error de red, no se recibió respuesta
                    $toast.error(getLocaleMessage('common', 'networkError'));
                } else {
                    // Otro tipo de error
                    $toast.error(getLocaleMessage('common', 'generalError'));
                }
            } finally {
                useLoadingStore().loading = false;
            }
        }
    }
});